<div class="grid-container" [ngStyle]="{'grid-template-columns':'repeat(' + chapters?.length + ', auto)'}">
	<div *ngFor="let chapter of chapters; let i = index" class="grid-item" [ngStyle]="{'border-right-color':'rgba(204, 204, 204,' + (zoom + 0.2) +')'}">
		<div class="zoom" *ngIf="zoom > 0.34">
			<div class="title-wrapper" *ngIf="!editMode[i]" (click)="editChapter(i)" [ngStyle]="{'pointer-events': (!allowEdit? 'none' :'auto')}">
				<h4>{{ chapter.title }}</h4>
				<span class="fe-icon-button" [ngStyle]="{'right' : emptyChapters.indexOf(chapter.id) !== -1 ? '25px' : '0' }">
					<i class="fa fa-edit"></i>
				</span>
				<span (click)="deleteChapter($event, i)" *ngIf="emptyChapters.indexOf(chapter.id) !== -1" class="delete-chapter-button fe-icon-button">
					<i class="fa fa-trash"></i>
				</span>
			</div>
			<div class="title-wrapper" *ngIf="editMode[i]">
				<input type="text" [(ngModel)]="chapter.title" (keydown.enter)="updateChapter(i)">
				<a class="button blue" (click)="updateChapter(i)">{{ 'OK' | translate }}</a>
			</div>
		</div>
	</div>
</div>
<div
	*ngFor="let hlc of highlight; let ci = index"
	class="highlight"
	[style.width]="(100 / chapters?.length) + '%'"
	[style.left]="100 + (ci * (100 / chapters?.length)) + '%'"
></div>
